import React from 'react'

import SwipeableViews from 'react-swipeable-views'

import ArrowRightIcon from 'app/assets/icons/arrow-right.svg'

import Box from '../Box'
import IconButton from '../IconButton'
import Stack from '../Stack'

interface SwiperItemsProps {
  navigation?: boolean
  pagination?: boolean
  onChangeIndex: React.Dispatch<React.SetStateAction<number>>
  activeIndex: number
}

const SwiperItems: RFC<SwiperItemsProps> = ({
  pagination = true,
  activeIndex,
  onChangeIndex,
  children
}) => {
  const arrayChildren = React.Children.toArray(children)
  const showNavigation = arrayChildren.length > 1

  const handleNextClick = (e) => {
    e.stopPropagation()
    onChangeIndex((prev) => {
      if (arrayChildren.length - prev === 1) {
        return 0
      }
      return prev + 1
    })
  }

  const handlePrevClick = (e) => {
    e.stopPropagation()
    onChangeIndex((prev) => {
      if (prev === 0) {
        return arrayChildren.length - 1
      }
      return prev - 1
    })
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <SwipeableViews
        index={activeIndex}
        onChangeIndex={onChangeIndex}
        resistance
        enableMouseEvents
      >
        {arrayChildren.map((el, index) => (
          <Box key={index}>{el}</Box>
        ))}
      </SwipeableViews>
      {showNavigation && (
        <Box>
          <IconButton
            onClick={handleNextClick}
            sx={{
              position: 'absolute',
              top: '50%',
              right: 8,
              transform: 'translateY(-50%)',
              backgroundColor: 'background.default',
              display: { xs: 'none', md: 'flex' },
              height: 24,
              width: 24
            }}
            disableRipple
            aria-label="image-navigation-arrow"
          >
            <ArrowRightIcon />
          </IconButton>

          <IconButton
            onClick={handlePrevClick}
            sx={{
              position: 'absolute',
              top: '50%',
              left: 8,
              transform: 'translateY(-50%) rotate(180deg)',
              backgroundColor: 'background.default',
              display: { xs: 'none', md: 'flex' },
              height: 24,
              width: 24
            }}
            disableRipple
            aria-label="image-navigation-arrow"
          >
            <ArrowRightIcon />
          </IconButton>
        </Box>
      )}
      {pagination && (
        <Stack
          direction="row"
          sx={{
            position: 'absolute',
            bottom: 10,
            left: '50%',
            transform: 'translateX(-50%)',
            gap: '5px'
          }}
        >
          {arrayChildren.map((item, index) => (
            <Box
              key={index}
              sx={{
                height: 6,
                width: 6,
                borderRadius: '50%',
                backgroundColor: 'primary.main',
                opacity: index === activeIndex ? 1 : 0.5
              }}
            />
          ))}
        </Stack>
      )}
    </Box>
  )
}

export default SwiperItems
